module.exports = __webpack_public_path__ + "static/media/invoice-right.95ab4997371763c6a43e742129e6af8f.png";